"use client";

import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] as [number, number, number, number] },
  },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

export default function AboutHero() {
  return (
    <section className="relative mx-auto max-w-6xl px-4 pt-24 pb-12 sm:px-8 sm:pt-32">
      {/* Optional background glow for the hero area */}
      <div className="pointer-events-none absolute -top-20 left-1/2 -z-10 h-[300px] w-[600px] -translate-x-1/2 rounded-full bg-[var(--accent)]/10 blur-[120px]" />

      <motion.div
        variants={staggerContainer}
        initial="hidden"
        animate="show"
        className="max-w-2xl"
      >
        <motion.p 
          variants={fadeUp}
          className="mb-4 inline-block rounded-full bg-[var(--accent)]/10 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-[var(--accent)]"
        >
          About Dev By Skillz
        </motion.p>
        <motion.h1 
          variants={fadeUp}
          className="text-4xl font-extrabold tracking-tight text-[var(--foreground)] sm:text-5xl lg:text-7xl lg:whitespace-nowrap"
        >
          The studio & the person.
        </motion.h1>
        <motion.p 
          variants={fadeUp}
          className="mt-6 text-lg leading-relaxed text-[var(--foreground-muted)] sm:text-xl"
        >
          A digital studio built on craft, consistency, and a refusal to ship anything less than the absolute best.
        </motion.p>
      </motion.div>
    </section>
  );
}
